import { render, staticRenderFns } from "./Indexv3.vue?vue&type=template&id=2af85802&scoped=true&"
import script from "./Indexv3.vue?vue&type=script&lang=js&"
export * from "./Indexv3.vue?vue&type=script&lang=js&"
import style0 from "./Indexv3.vue?vue&type=style&index=0&id=2af85802&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af85802",
  null
  
)

export default component.exports